<div mat-dialog-title class="bg-primary mat-elevation-z5">
  {{ signalModalParams().headerText }}
  <button mat-icon-button class="pull-right" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  @if (!signalModalParams().allowHtml) {
    <div>
      {{ signalModalParams().bodyText }}
    </div>
  }
  @if (signalModalParams().allowHtml) {
    <div [innerHtml]="signalModalParams().bodyText"></div>
  }
</div>

<div mat-dialog-actions class="w-100 generic-modal-actions-flex">
  <div class="generic-modal-actions-error error-message">&nbsp;</div>
  <div class="generic-modal-actions-spacer">&nbsp;</div>
  <div class="generic-modal-actions-buttons">
    <div class="footer-buttons">
      @if (showCancelButton()) {
        <button mat-button color="warn" (click)="cancel()">
          {{ signalModalParams().cancelText }}
        </button>
      }
      <button mat-raised-button color="primary" (click)="ok()">
        {{ signalModalParams().okText }}
      </button>
    </div>
  </div>
</div>
